import { ReactNode, useState } from 'react';

import { WildCardItemInfo } from 'src/types/WildCardItemInfo';

import { defaultWildCardRouteState, WildCardRouteContext } from './WildCardRouteContext';

type WildCardRouteProviderProps = {
	children: ReactNode;
};

export function WildCardRouteProvider(props: WildCardRouteProviderProps): JSX.Element {
	const [wildCardItemInfo, setWildCardItemInfo] = useState<WildCardItemInfo | undefined>(defaultWildCardRouteState.wildCardItemInfo);

	function updateWildCardItemInfo(item: WildCardItemInfo | undefined) {
		setWildCardItemInfo(item);
	}

	return (
		<WildCardRouteContext.Provider
			value={{
				wildCardItemInfo: wildCardItemInfo,
				updateWildCardItemInfo: updateWildCardItemInfo,
			}}
		>
			{props.children}
		</WildCardRouteContext.Provider>
	);
}
